import axios from 'axios';
import https from 'https';

export * from './hooks/use-service';
export * from './messages.service';

const withCredentials = process.env.TARGET_ENV === 'local';

const instance = ({ headers = {}, ...otherConfig }) =>
  axios.create({
    timeout: 120000,
    withCredentials,
    httpsAgent: new https.Agent({ rejectUnauthorized: true }),
    transformRequest: [data => JSON.stringify(data.data)],
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      ...headers,
    },
    ...otherConfig,
  });

export default instance;
